import React, { useRef, useEffect, useState } from 'react';

interface VideoBackgroundProps {
  videoSrc?: string;
  overlayOpacity?: number;
  className?: string;
}

const VideoBackground: React.FC<VideoBackgroundProps> = ({
  videoSrc = '/videos/2.mp4',
  overlayOpacity = 0.8,
  className = ''
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadedData = () => {
      setIsLoaded(true);
    };

    const handleError = (e: Event) => {
      console.error('Error loading video:', e);
    };

    video.addEventListener('loadeddata', handleLoadedData);
    video.addEventListener('error', handleError);

    // Set video properties
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.playbackRate = 1.0;

    return () => {
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <div className={`fixed inset-0 z-[-1] overflow-hidden ${className}`}>
      {/* Video Background */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        style={{
          filter: 'brightness(0.3) contrast(0.7) saturate(0.5)',
          transform: 'scale(1.05)', // Slight zoom to avoid black edges
        }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay for better text readability */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-cosmic-violet/70 to-purple-900/80"
        style={{ opacity: overlayOpacity }}
      />

      {/* Optional: Loading state */}
      {!isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-cosmic-violet to-purple-900">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
        </div>
      )}
    </div>
  );
};

export default VideoBackground; 